export enum TimelineDisplay {
    Default = 0,
    Requisition = 1,
    Dashboardside = 2
  }
  